import { MarkdownReact } from "@/components/MarkdownReact";

/**
 * Renders body content as rich text using markdown.
 * Bodies are normalized to markdown on the backend, so this component
 * only needs to handle markdown rendering.
 * @param body - The body text to render (markdown format)
 */
export const BodyRenderer = ({ body }: { body: string }) => {
  return (
    <div className="text-xs text-muted-foreground break-words max-w-none [&_p]:my-1 [&_a]:text-primary [&_a]:underline [&_blockquote]:border-l-2 [&_blockquote]:pl-2 [&_blockquote]:italic [&_blockquote]:text-muted-foreground [&_h1]:text-xs [&_h2]:text-xs [&_h3]:text-xs [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_ul]:list-disc [&_ul]:pl-4 [&_ol]:list-decimal [&_ol]:pl-4">
      <MarkdownReact>{body}</MarkdownReact>
    </div>
  );
};
